import { render } from "./ProductPhotoPreview.vue?vue&type=template&id=7793d776&scoped=true"
import script from "./ProductPhotoPreview.vue?vue&type=script&lang=js"
export * from "./ProductPhotoPreview.vue?vue&type=script&lang=js"

import "./ProductPhotoPreview.vue?vue&type=style&index=0&id=7793d776&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7793d776"]])

export default __exports__